const TOOLS_PERMISSION = 'ade.portal.tools_perm'
const PORTAL_CONTEXT = 'ADE_PORTAL_CONTEXT'

const ADE_WS_HOST = 'https://ade-python-ws.us-east-1.elasticbeanstalk.com'

const ADE_CHAT_BASE_URL = '/service/match/ade/chat'

// const ADE_CHAT_BASE_URL = 'http://localhost:8000'

// The ORN readiness report API (registered name orn-store.ade.match.service).
// Relative like ADE_CHAT_BASE_URL: same host as the portal, session travels, no
// CORS. Until the binding deploys this 404s WITHOUT the service's JSON envelope,
// which ornReportApi reports as an error rather than "no report yet".
const ORN_REPORT_BASE = '/service/match/ade/orn-store'

export { TOOLS_PERMISSION, PORTAL_CONTEXT, ADE_WS_HOST, ADE_CHAT_BASE_URL, ORN_REPORT_BASE }
